export const APP_VERSION = 'v2604171600';
